import { ForbiddenError } from "src/api/client";
import { Empty } from "src/components/ui";

/**
 * What a screen shows when a read fails.
 *
 * A refusal gets its own words. Every other failure keeps the backend's message,
 * which is the only thing separating a network blip from a rejected filter — but a
 * refusal's message is internal vocabulary ("forbidden: no readable population"),
 * and showing it tells somebody who simply lacks access that the console is broken.
 *
 * Names who to ask, matching the login flow's own no-access page, because that is
 * the only action available to the person reading it.
 *
 * One component rather than the same ternary at six call sites: a refusal that reads
 * as a refusal on five screens and as `forbidden: …` on the sixth is the defect this
 * replaces, not a smaller version of it.
 */
export function ReadFailure({ error }: { error: Error }) {
  if (error instanceof ForbiddenError) {
    return <Empty>You do not have access to this. Ask an administrator to grant it.</Empty>;
  }
  return <Empty>{error.message}</Empty>;
}
